var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:[
		'btn-icon',
		..._vm.variantClassList,
		_vm.disabledClass(),
		_vm.selected && 'is-selected',
		_vm.isLoading && 'is-loading',
		_vm.hasLoaded && 'has-loaded'
	],attrs:{"id":_vm.uid,"disabled":_vm.disabled,"type":_vm.type,"aria-label":_vm.ariaLabel,"title":_vm.title}},{ ..._vm.$listeners, click: _vm.onClick }),[_c('div',{staticClass:"btn-icon__wrapper"},[(_vm.variant === 'rotate')?_c('span',{staticClass:"btn-icon__icon"},[_c('i',{class:['icon', _vm.iconClassName]})]):_c('i',{class:['icon', _vm.iconClassName]}),(_vm.showBadge && _vm.variant !== 'rotate')?_c('Badge',{class:[
				'btn-icon__badge',
				_vm.badgeLeading && 'btn-icon__badge--leading',
				_vm.badgeTrailing && 'btn-icon__badge--trailing',
				_vm.badgeTopLeft && 'btn-icon__badge--top-left',
				_vm.badgeTopRight && 'btn-icon__badge--top-right'
			],attrs:{"text":_vm.badgeContent,"visible":_vm.showBadge}}):_vm._e()],1),_c('ButtonProgress',{attrs:{"isLoading":_vm.isLoading,"hasLoaded":_vm.hasLoaded,"hasError":_vm.hasError,"errorMessage":_vm.errorMessage,"isOutline":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }